/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

interface TypePercent {
  NAME: string;
  PERCENT: number;
}

/**
 *
 * @export
 * @interface StageImageResponse
 */
export interface StageImageResponse {
  /**
   *
   * @type {number}
   * @memberof StageImageResponse
   */
  id: number;
  /**
   *
   * @type {Date}
   * @memberof StageImageResponse
   */
  /**
   *
   * @type {Array<string>}
   * @memberof StageImageResponse
   */
  images: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof StageImageResponse
   */
  videos: Array<string>;
  /**
   *
   * @type {string}
   * @memberof StageImageResponse
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof StageImageResponse
   */
  house: number;
  /**
   *
   * @type {number}
   * @memberof StageImageResponse
   */
  percent: number;
  /**
   *
   * @type {Array<TypePercent>}
   * @memberof StageImageResponse
   */
  typePercents: Array<TypePercent>;
}

export function StageImageResponseFromJSON(json: any): StageImageResponse {
  return StageImageResponseFromJSONTyped(json, false);
}

export function StageImageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StageImageResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json['id'],
    images: json['images'],
    videos: json['videos'],
    name: json['name'],
    house: json['house'],
    percent: json['percent'],
    typePercents: json['typePercents'],
  };
}

export function StageImageResponseToJSON(value?: StageImageResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    images: value.images,
    videos: value.videos,
    name: value.name,
    house: value.house,
    percent: value.percent,
    typePercents: value.typePercents,
  };
}
